'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _normalizr = require('normalizr');

var _customerSchema = require('./customerSchema');

var _customerSchema2 = _interopRequireDefault(_customerSchema);

var _serviceSchema = require('./serviceSchema');

var _serviceSchema2 = _interopRequireDefault(_serviceSchema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requirementSchema = new _normalizr.Schema('requirements', {
    // TODO: Consider subbing for random id generator (this is only really useful for debugging)
    idAttribute: function idAttribute(requirement) {
        var services = requirement.services.map(function (s) {
            return s.id;
        }).join('-');
        return requirement.customer.id + '-' + requirement.code + '-' + services;
    }
});

requirementSchema.define({
    customer: _customerSchema2.default,
    services: (0, _normalizr.arrayOf)(_serviceSchema2.default, { schemaAttribute: 'type' })
});

exports.default = requirementSchema;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/api/schemas/requirementSchema.js
// module id = 1291
// module chunks = 0